import { useEffect, useState } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import PageContainer from "../../Components/Page/PageContainer";
import { TabMenu } from "primereact/tabmenu";
import { Card } from "primereact/card";
import NewIssuesBanner from "../../Components/NewIssuesBanner/NewIssuesBanner";

import { ROUTES } from "../../config/routes";

const DSRAudits = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState<number>(0);

  // Sync active tab with current route
  useEffect(() => {
    const path = location.pathname;
    // Set active tab based on current route
    if (path.includes(ROUTES.DSR_GENENT)) {
      setActiveIndex(0);
    } else if (path.includes(ROUTES.DSR_MUSIC_VIDEOS)) {
      setActiveIndex(1);
    } else if (path.includes(ROUTES.DSR_SOUND_RECORDINGS)) {
      setActiveIndex(2);
    } else if (path.includes(ROUTES.DSR_MASTER_ARTISTS)) {
      setActiveIndex(3);
    } else if (path.includes(ROUTES.DSR_SFTP)) {
      setActiveIndex(4);
    } else {
      setActiveIndex(-1); // No tab selected for dashboard
    }
  }, [location.pathname]);

  const handleTabChange = (e: { index: number }) => {
    if (e.index === 0) {
      navigate(ROUTES.DSR_GENENT);
    } else if (e.index === 1) {
      navigate(ROUTES.DSR_MUSIC_VIDEOS);
    } else if (e.index === 2) {
      navigate(ROUTES.DSR_SOUND_RECORDINGS);
    } else if (e.index === 3) {
      navigate(ROUTES.DSR_MASTER_ARTISTS);
    } else if (e.index === 4) {
      navigate(ROUTES.DSR_SFTP);
    }
  };

  const items = [
    { label: "GenEnt Reports", icon: "pi pi-palette" },
    { label: "Music Videos Reports", icon: "pi pi-video" },
    { label: "Sound Recordings Reports", icon: "pi pi-microphone" },
    { label: "Master Artists", icon: "pi pi-users" },
    { label: "BMAT SFTP", icon: "pi pi-upload" },
  ];

  return (
    <>
      {/* Real-time notification banner */}
      <NewIssuesBanner
        collections={["DSRHealthMetrics"]}
        position="top"
        showCount={true}
      />

      <PageContainer
        HomeMenuBarprops={{
          title: (
            <span
              style={{ cursor: "pointer", fontWeight: "bold" }}
              onClick={() => navigate(ROUTES.DSR_AUDITS)}
            >
              Music DSR Audits
            </span>
          ),

          Tabs: (
            <TabMenu
              activeIndex={activeIndex}
              onTabChange={handleTabChange}
              model={items}
            />
          ),
        }}
      >
        <div
          style={{
            width: "96%",
            margin: "0 auto",
          }}
        >
          <Card
            unstyled
            style={{
              marginTop: "2rem",
              boxShadow: "none",
            }}
          >
            {/* Use Outlet for sub-routes */}
            <Outlet />
          </Card>
        </div>
      </PageContainer>
    </>
  );
};

export default DSRAudits;
